import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from "rxjs";
import { FuseLoadingService } from "../../@fuse/services/loading";

@Injectable({
    providedIn: 'root'
})
export class GlobalConfigService {

    public demoMode$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public destroy = this.ngOnDestroy;
    private loadingService: FuseLoadingService = inject(FuseLoadingService);
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor() {
        this.loadingService.show$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value: boolean) => this._loading = value);
    }

    public _loading: boolean = false;

    get loading(): boolean {
        return this._loading;
    }

    set loading(value: boolean) {
        this._loading = typeof value !== "boolean" ? !this._loading : value;
        this.loadingService._setLoadingStatus(this._loading, 'das-url');
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

}
